import { AwardJudge } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardJudges: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<AwardJudge[]> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/judges`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardJudge[]>(fetchContext.errorStore, response, 'get award judges'));
